'use client';

import { createBrowserClient } from '@supabase/ssr';

// Exception: reads process.env directly because lib/config.ts has 'server-only' guard.
// NEXT_PUBLIC_* vars are safe — inlined by Next.js at build time.
export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  );
}
